export default __webpack_public_path__ + "static/media/weather-app-screenshot.71c73916.png";